import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getGeneralLeaveListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const params = { lookupHdrId: "LEAVE_TYPE", sort: "seq,asc" };
		const res = await api.get.general.list(params);
		response = res.map(({ lookupTitle, lookupValue, ...o }) => ({ ...o, label: lookupTitle, value: lookupValue }));
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return { content: response };

	throw errorMessage;
};

export default getGeneralLeaveListing;
